import request from "../request";

export const getLcElements = (curriculumId) =>
  request.get(`curriculum/${curriculumId}/lc-element`).then((res) => res);

export const createLcElement = (curriculumId, data) =>
  request.post(`curriculum/${curriculumId}/lc-element`, data).then((res) => res);

export const updateLcElement = (curriculumId, id, data) =>
  request.put(`curriculum/${curriculumId}/lc-element/${id}`, data).then((res) => res);

export const deleteLcElement = (curriculumId, id) =>
  request.delete(`curriculum/${curriculumId}/lc-element/${id}`).then((res) => res);
